// eslint-disable-next-line max-classes-per-file
import { SUREbusinessCommonDomainEntityReferencesSbEntityType as SbEntityType } from '@services/communicatie-public/orval-api/model/sUREbusinessCommonDomainEntityReferencesSbEntityType';
import { type MaybeRef, isRef, computed } from 'vue';

export abstract class EntityReference {
  protected constructor(
    public readonly entityId: MaybeRef<string | undefined>,
    public readonly entityType: SbEntityType,
  ) {}
}

export class InspectieEntityReference extends EntityReference {
  constructor(public readonly inspectieId: MaybeRef<string | undefined>) {
    super(inspectieId, SbEntityType.InspectieAanvraag);
  }
}

export class AanvraagReference extends EntityReference {
  constructor(public readonly aanvraagId: MaybeRef<number | undefined>) {
    super(maybeNumberToString(aanvraagId), SbEntityType.Aanvraag);
  }
}

export class MaatwerkReference extends EntityReference {
  constructor(public readonly maatwerkId: MaybeRef<number | undefined>) {
    super(maybeNumberToString(maatwerkId), SbEntityType.Maatwerk);
  }
}

export class KantoorDocumentReference extends EntityReference {
  constructor(public readonly adviseurId: MaybeRef<number | undefined>) {
    super(maybeNumberToString(adviseurId), SbEntityType.KantoorDocument);
  }
}
function maybeNumberToString(input: MaybeRef<number | undefined>): MaybeRef<string | undefined> {
  return isRef(input) ? computed(() => String(input.value)) : String(input);
}
